import { IOConnectHome, IOConnectHomeConfig, SystemLoader } from "@interopio/home-ui-react";
import { useEffect, useState } from "react";
import { getIoConfig } from "./utils/getIoConfig";

const Main = () => {
    const [config, setConfig] = useState<any>(null);

    useEffect(() => {

        const loadConfig = async () => {
            const configUrl = "/config/config-ui.json";
            const response = await fetch(configUrl);
            const config = await response.json();

            setConfig(config);

        };

        loadConfig();
    }, []);

    if (!config) {
        return (
            <div className="welcome flex flex-column ai-center">
                <SystemLoader />
            </div>
        );
    }

    const redirectUrl = process.env.REACT_APP_AUTH_REDIRECT_URL ?? config.home.redirectUrl ?? window.location.origin;

    const urlParams = new URLSearchParams(window.location.search);
    const auth0InvitationId = urlParams.get('invitation') ?? undefined;

    const authParams: any = {
        audience: config.auth0.audience,
        redirect_uri: redirectUrl,
        organization: config.auth0.organizationId?.length ? config.auth0.organizationId : undefined,
        invitation: auth0InvitationId?.length ? auth0InvitationId : undefined
    };

    const ioConnectHomeConfig: IOConnectHomeConfig = {
        getIOConnectConfig: (user) => getIoConfig(config.corePlus, user),
        login: {
            type: 'auth0',
            validateUser: (user) => {

                const userExpired = user.metadata?.expirationDate && user.metadata.expirationDate < Date.now();

                if (userExpired) {
                    return { ok: false, message: 'User has expired. Please contact sales@interop.io for further assistance.' };
                }

                return { ok: true };
            },
            providerOptions: {
                domain: config.auth0.issuerDomain,
                clientId: config.home.clientId,
                authorizationParams: authParams,
            },
        }
    };

    return <IOConnectHome config={ioConnectHomeConfig} />;
};

export default Main;